import React, { useState, useEffect } from "react";
import axios from "axios";
import { ADMIN_URL } from "../utils/constants";

export const UserContext = React.createContext({
	user: null,
	setUser: () => {},
});

export const UserProvider = ({ children }) => {
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState(null);

	const getUser = async () => {
		try {
			const searchParams = new URLSearchParams(window.location.search);
			if (searchParams.has("session")) {
				if (searchParams.get("session")) {
					localStorage.setItem("token", searchParams.get("session"));
				}

				window.history.pushState({}, document.title, window.location.pathname);
			}

			let user = await axios.get(ADMIN_URL + "user", {
				params: {},
				headers: { Authorization: localStorage.getItem("token") },
			});

			if (user) {
				setUser(user.data.user);
				try {
					window.Tawk_API.login(
						{
							hash: user.data.user.tawkHash,
							userId: user.data.user.id,
							name: user.data.user.name,
							email: user.data.user.email,
						},
						(error) => {
							// do something if error
							console.log(error);
						}
					);
				} catch (error) {
					console.log(error);
				}
			} else {
				setUser(null);
				try {
					window.Tawk_API.logout(function (error) {
						// do something if error
					});
				} catch (error) {
					console.log(error);
				}
			}
		} catch (error) {
			setUser(null);
			console.log(error);
			try {
				window.Tawk_API.logout(function (error) {
					// do something if error
				});
			} catch (error) {
				console.log(error);
			}
		}

		setLoading(false);
	};

	useEffect(() => {
		if (!window.location.href.includes("account-deletion")) {
			getUser();
		} else {
			setLoading(false);
		}
	}, []);

	return (
		<UserContext.Provider
			value={{
				user,
				setUser,
				getUser,
			}}
		>
			{loading ? null : children}
		</UserContext.Provider>
	);
};
